export const about = {
  hero: {
    home: 'Home',
    aboutUs: 'About Us',
    title: 'About EINA',
    intro: 'Ste EINA Ltd is a leading provider of advanced separation and purification technologies, specializing in comprehensive filtration solutions for diverse industrial applications in Cameroon and Africa.',
    paragraph1: 'Our team of experienced engineers combines deep scientific expertise with practical industrial knowledge to deliver customized solutions that optimize process performance, enhance product quality, and reduce operational costs.',
    paragraph2: 'Through strategic partnerships with world-class manufacturers and continuous innovation in filtration technologies, we ensure our clients receive the most effective and reliable purification systems and media for their specific requirements.',
  },
  journey: {
    title: 'Our Journey',
    subtitle: 'Building excellence in industrial filtration through continuous innovation and commitment to client success',
    milestones: [
      {
        year: '2014',
        title: 'Company Founded',
        description: 'Ste EINA Ltd established with a vision to provide advanced filtration solutions to industrial clients',
        image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20company%20founding%20moment%20with%20professional%20team%20and%20advanced%20filtration%20equipment%20in%20clean%20facility%20showing%20innovation%20and%20expertise%20with%20green%20and%20white%20tones&width=400&height=300&seq=milestone-001&orientation=landscape',
      },
      {
        year: '2016',
        title: 'Global Partnerships',
        description: 'Strategic alliances formed with leading international filtration technology manufacturers',
        image: 'https://readdy.ai/api/search-image?query=international%20business%20partnership%20handshake%20with%20global%20industrial%20equipment%20and%20world%20map%20background%20showing%20collaboration%20and%20trust%20in%20professional%20corporate%20setting&width=400&height=300&seq=milestone-002&orientation=landscape',
      },
      {
        year: '2018',
        title: 'Technology Expansion',
        description: 'Expanded portfolio to include comprehensive range of membrane and depth filtration technologies',
        image: 'https://readdy.ai/api/search-image?query=advanced%20membrane%20filtration%20technology%20laboratory%20with%20modern%20equipment%20and%20scientific%20instruments%20showing%20technological%20innovation%20and%20research%20development%20in%20clean%20professional%20environment&width=400&height=300&seq=milestone-003&orientation=landscape',
      },
      {
        year: '2022',
        title: 'Industry Recognition',
        description: 'Achieved ISO certification and recognition as trusted provider across multiple industrial sectors',
        image: 'https://readdy.ai/api/search-image?query=ISO%20certification%20award%20and%20quality%20recognition%20with%20professional%20industrial%20facility%20background%20showing%20excellence%20and%20achievement%20in%20clean%20modern%20setting%20with%20green%20accents&width=400&height=300&seq=milestone-004&orientation=landscape',
      },
    ],
  },
  missionVision: {
    title: 'Our Foundation',
    subtitle: 'Guided by clear principles and unwavering commitment to excellence',
    mission: {
      title: 'Mission',
      description: 'To deliver advanced filtration and purification solutions that optimize industrial processes, enhance product quality, and drive operational excellence for our clients in Cameroon and Africa.',
    },
    vision: {
      title: 'Vision',
      description: 'To be the global leader in industrial separation technologies, recognized for innovation, technical expertise, and unwavering commitment to client success and environmental sustainability.',
    },
    values: {
      title: 'Values',
      description: 'Innovation, Technical Excellence, Reliability, Sustainability, Cost Optimization, Client Partnership, Continuous Improvement, and Ethical Business Practices.',
    },
    valuesInAction: 'Our Core Values in Action',
    innovation: 'Innovation',
    excellence: 'Excellence',
    reliability: 'Reliability',
    sustainability: 'Sustainability',
    costOptimization: 'Cost Optimization',
    partnership: 'Partnership',
    improvement: 'Improvement',
    ethics: 'Ethics',
  },
  expertise: {
    title: 'Technical Expertise',
    subtitle: 'Combining scientific knowledge with practical industrial experience to deliver optimal solutions',
    scientificApproach: 'Scientific Approach & Engineering Excellence',
    scientificDesc1: 'Our team of experienced engineers and filtration specialists brings decades of combined expertise in separation technologies. We apply rigorous scientific methodology to analyze process requirements, identify optimal solutions, and implement systems that deliver measurable performance improvements.',
    scientificDesc2: 'Through comprehensive understanding of fluid dynamics, membrane science, and industrial processes, we design customized filtration systems that address specific challenges while optimizing efficiency, product quality, and operational costs.',
    customization: 'Customization & Flexibility',
    customizationDesc1: 'Every industrial application presents unique requirements. We excel at developing tailored solutions that integrate seamlessly with existing processes, accommodate specific constraints, and scale to meet evolving production demands.',
    customizationDesc2: 'Our flexible approach ensures that whether you need a complete turnkey system or targeted process improvements, we deliver solutions that align perfectly with your operational objectives and budget parameters.',
    continuousImprovement: 'Continuous Process Improvement',
    continuousDesc: 'We maintain ongoing partnerships with our clients, providing technical support, performance monitoring, and optimization recommendations to ensure sustained excellence. Our commitment extends beyond initial installation to long-term process enhancement and operational success.',
    keyCompetencies: 'Key Competencies',
    membraneTechnology: 'Membrane Technology',
    processEngineering: 'Process Engineering',
    industrialApplications: 'Industrial Applications',
    technicalConsulting: 'Technical Consulting',
    systemIntegration: 'System Integration',
    qualityAssurance: 'Quality Assurance',
    certificationsTitle: 'Certifications & Quality Standards',
    iso9001: 'ISO 9001:2015',
    qualityManagement: 'Quality Management',
    iso14001: 'ISO 14001',
    environmentalManagement: 'Environmental Management',
    industryCertified: 'Industry Certified',
    technicalExcellence: 'Technical Excellence',
  },
  international: {
    title: 'International Presence',
    subtitle: 'Strategic partnerships with leading global manufacturers ensure quality, availability, and comprehensive support',
    globalPartnerNetwork: 'Global Partner Network',
    globalDescription: 'Serving clients worldwide through strategic international partnerships',
    globalNetwork: 'Global Network',
    supplyContinuity: 'Supply Continuity',
    localSupport: 'Local Support',
    qualityAssurance: 'Quality Assurance',
    globalNetworkDesc: 'Access to worldwide manufacturing and distribution capabilities',
    supplyContinuityDesc: 'Guaranteed product availability and reliable delivery schedules',
    localSupportDesc: 'Technical assistance and service in your region',
    qualityAssuranceDesc: 'International standards and certified manufacturing processes',
    readyToWork: 'Ready to Work Together?',
    readyDescription: 'Discover how our global network and technical expertise can optimize your industrial processes',
    requestStudy: 'Request Technical Study',
    contactUs: 'Contact Us',
  },
};